import { lazy } from "react";

const villaDetailImport = () =>
  import(
    /* webpackChunkName: "villa-detail" */
    /* webpackPrefetch: true */
    "../components/VillaDetail/VillaDetail"
  );

const reservationRequestsImport = () =>
  import(
    /* webpackChunkName: "reservations" */
    /* webpackPrefetch: true */
    "../components/ReservationRequests/ReservationRequests"
  );

const regionDetailImport = () =>
  import(
    /* webpackChunkName: "region-detail" */
    /* webpackPrefetch: true */
    "../components/RegionDetail/RegionDetail"
  );

export const VillaDetail = lazy(villaDetailImport);
export const ReservationRequests = lazy(reservationRequestsImport);
export const RegionDetail = lazy(regionDetailImport);

export function preloadVillaDetail() {
  return villaDetailImport();
}

export function preloadReservationRequests() {
  return reservationRequestsImport();
}

export function preloadRegionDetail() {
  return regionDetailImport();
}

export function preloadAllRouteChunks() {
  preloadVillaDetail();
  preloadReservationRequests();
  preloadRegionDetail();
}

export function preloadRouteChunksWhenIdle() {
  const run = () => preloadAllRouteChunks();

  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(run, { timeout: 2500 });
  } else {
    window.setTimeout(run, 1200);
  }
}

export function withRoutePreload(preloadFn, handler) {
  return (event) => {
    preloadFn();
    if (handler) handler(event);
  };
}
